import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Provider } from 'react-redux';
import { MsalProvider } from '@azure/msal-react';
import { PublicClientApplication } from '@azure/msal-browser';
import { Suspense } from 'react';
import "bootstrap/dist/css/bootstrap.min.css";
import './App.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

import Layout from './components/layout/Layout';
import store from './store';
import { msalConfig } from './config/authConfig';
import PrivateRoute from './routeGuard/PrivateRoute';
import PublicRoute from './routeGuard/PublicRoute';
import ROUTE_SOURCES from './constants/routeSource';
import { Spinner } from './components/loader/view/Loader';

// Initialize MSAL instance with error handling
let msalInstance;
try {
  msalInstance = new PublicClientApplication(msalConfig);
} catch (error) {
  throw new Error(`MSAL initialization failed: ${error.message}`);
}

function App() {

  const renderRoutes = () => {
    return (
      <Suspense fallback={<Spinner />}>
        <Routes>
          {ROUTE_SOURCES.map(({ path, component: Component, isPublic, hasParam, allowAuthenticated, allowedRoles }, index) => (
            <Route
              key={path}
              path={hasParam ? `${path}/:paramId?` : path}
              element={
                isPublic && allowAuthenticated ? (
                  <Layout isShowSidebar={false} isLoginPage={true}><Component /></Layout>
                ) : isPublic ? (
                  <PublicRoute>
                    <Layout isShowSidebar={false} isLoginPage={true}><Component /></Layout>
                  </PublicRoute>
                ) : (
                  <PrivateRoute allowedRoles={allowedRoles}>
                    <Layout><Component /></Layout>
                  </PrivateRoute>
                )
              }
            />
          ))}
        </Routes>
      </Suspense>
    )
  };

  return (
    <MsalProvider instance={msalInstance}>
      <Provider store={store}>
        <BrowserRouter>
          {renderRoutes()}
        </BrowserRouter>
      </Provider>
    </MsalProvider>
  );
}

export default App;